import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';

type PromotedOrderToolbarProps = { height:number, onSelect:any }
const PromotedOrderToolbar = ({ height, onSelect }:PromotedOrderToolbarProps) => {
    const [ acceptOptionsVisible, setAcceptOptionsVisible ] = useState(false);
    if(acceptOptionsVisible){
        return (
        <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', padding:5 }}>
            <TouchableOpacity style={ [localStyles.shadowBox, {margin:5, borderRadius:100, height, width:height, justifyContent:'center', alignItems:'center' }]} onPress={() => setAcceptOptionsVisible(false)}>
                <Icon name='x' type='feather' color={Colors.utility.error} size={28}/>
            </TouchableOpacity>
            <TouchableOpacity style={ [localStyles.shadowBox, {margin:5, paddingRight:10, backgroundColor:Colors.utility.success, paddingLeft:10, borderRadius:100, height, justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('accept_all')}>
                <Text size={12} color={Colors.shades.white} weight='bold' textAlign='center'>ACCEPT ALL</Text>
            </TouchableOpacity>
            <TouchableOpacity style={ [localStyles.shadowBox, {margin:5, paddingRight:10, paddingLeft:10, borderRadius:100, height, justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('accept_partial')}>
                <Text size={12} color={Colors.utility.success} weight='bold' textAlign='center'>ACCEPT PARTIAL</Text>
            </TouchableOpacity>
        </View>
        )
    }
    return (
        <View>
            <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', height:40, padding:5 }}>
                <TouchableOpacity style={ [localStyles.shadowBox, { flexDirection:'row', padding:10, margin:5, borderRadius:18, justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('decline')}>
                    <Icon name='x' type='feather' color={Colors.utility.error} size={20}/>
                    <Text size={14} weight='semibold' color={Colors.brand.midnight} style={{ marginLeft:5 }}>Decline</Text>
                </TouchableOpacity>
                <TouchableOpacity style={ [localStyles.shadowBox, { flexDirection:'row', padding:10, margin:5, borderRadius:18,  justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('skip')}>
                    <Icon name='skip-forward' type='feather' color={Colors.brand.slate} size={20}/>
                    <Text size={14} weight='semibold' color={Colors.brand.midnight} style={{marginLeft:5}}>Skip</Text>
                </TouchableOpacity>
                <TouchableOpacity style={ [localStyles.shadowBox, { flexDirection:'row', padding:10, margin:5, borderRadius:18,  justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('accept')}>
                    <Icon name='check' type='feather' color={Colors.utility.success} size={20}/>
                    <Text size={14} weight='semibold' color={Colors.brand.midnight} style={{marginLeft:5}}>Accept</Text>
                </TouchableOpacity>
                <TouchableOpacity style={ [localStyles.shadowBox, { flexDirection:'row', padding:10, margin:5, borderRadius:18, justifyContent:'center', alignItems:'center' }]} onPress={() => onSelect('all')}>
                    <Icon name='minimize' type='feather' color={Colors.brand.slate} size={20}/>
                </TouchableOpacity>
            </View>
        </View>
        
    )
}

const localStyles = {
    shadowBox: { shadowColor: "rgba(0, 0, 0, 0.16)", shadowOffset: { width: 0, height: 3 }, shadowRadius: 12, shadowOpacity: 1, elevation:5  }
}

export default PromotedOrderToolbar